import { useEffect, useState } from "react";
import { requestGetEnvironmentList } from "services/acadReinforce/relatedToAcadReinforce";
import { INITIAL_STATE } from "../reducer/acadReinforce.reducer";

const useEnvironmentList = ({
    loadingRequest, 
    acadReinforceResumeData,
    changingStep, 
    form: { step1, step2 }, changeFormStep2
}) => {
    //#region States
    const [environmentList, setEnvironmentList] = useState([]);
    const [firstCleaning, setFirstCleaning] = useState(true);
    //#endregion
    //#region Effects
    useEffect(() => {
        refresh();
    }, [
        step1.part3.quantityVacancy,
        step2.part2.duration.date,
        step2.part2.duration.time,
        step2.part3.place.campus,
        step2.part3.place.environmentTypeId
    ]);
    // useEffect()
    //#endregion
    //#region Functions
    const clearEnvironmentId = () => {
        changeFormStep2("part3", "place", prev => ({
            ...prev, 
            environment: { ...INITIAL_STATE.form.step2.part3.place.environment }
        }));
    }
    const refresh = async () => {
        if (!isValidParams()) return;
        await fillEnvironmentList();
        if (firstCleaning) {
            setFirstCleaning(false);
            return;
        }
        if (changingStep.value) {
            changingStep.set(false);
            return;
        }
        clearEnvironmentId();
    }
    const getParamsForRequest = () => {
        const { part3: { quantityVacancy } } = step1;
        const {
            part2: {
                duration: {
                    date, time
                }
            },
            part3: { 
                place: {
                    campus,
                    environmentTypeId
                }
            }
        } = step2;
        return {
            campusId: campus.id,
            environmentTypeId,
            quantityVacancy, date, time
        };
    }
    const isValidParams = () => {
        const params = getParamsForRequest();
        return (
            params.campusId > 0 && params.date > -1 && 
            params.environmentTypeId.length > 0 && Number(params.quantityVacancy) > 0 && 
            params.time.start > -1 && params.time.end > -1 && params.time.end > params.time.start
        );
    }
    const fillEnvironmentList = async () => {
        if (!acadReinforceResumeData?.step2) return;
        loadingRequest.show("Cargando ambientes...");
        let data = await requestGetEnvironmentList(getParamsForRequest());
        let currentEnvironment = null;
        const { place } = acadReinforceResumeData.step2;
        if (firstCleaning && place)
            currentEnvironment = place.environment;
        if (currentEnvironment && !data.some(({ id }) => id === currentEnvironment.id))
            data.push({
                ...currentEnvironment
            });
        setEnvironmentList(data);
        loadingRequest.hide("Cargando ambientes...");
    }
    //#endregion
    return environmentList;
}

export default useEnvironmentList;